
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function Privacy() {
  return (
    <div className="container" style={{ paddingTop: "150px", paddingBottom: "80px" }}>
      <Header />

      <div className="card">
        <h2 className="app-heading">Privacy Policy</h2>
        <p>
          Your privacy is important to us. SmartPackr does not collect or share any
          personal data. All your profiles, trip details, and preferences are stored
          locally in your browser — meaning your information never leaves your device.
        </p>
        <p>
          We do not use cookies, tracking scripts, or analytics tools that collect
          personal data. Any data you enter is used solely to generate your packing list.
        </p>
        
      </div>

      <div className="footer-nav">
        <nav>
            <Link to="/">Home</Link>
            <span>•</span>
            <Link to="/blog">Blog</Link>
            <span>•</span>
            <Link to="/about">About</Link>
            <span>•</span>
            <Link to="/privacy">Privacy Policy</Link>
        </nav>
        <p>© {new Date().getFullYear()} SmartPackr. All rights reserved.</p>
      </div>
    </div>
  );
}
